import React from 'react';

import { InterventionList } from 'components';

export const PageInterventionList = () => (
  <InterventionList />
);
